import script from "./currencyCommons.vue?vue&type=script&lang=js"
export * from "./currencyCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__